import React, { useState } from "react";
import PropTypes from "prop-types";
import localization from "assets/localization/localization";

const TagsInventoryDetail = ({ heading, details }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleItem = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="panel-card">
      <div className="panel-heading">{heading}</div>
      <div className="panel-body">
        <div className="details-listing">
          <div className="w-100">
            {details.map((obj, index) => (
              <div key={index} className="card mb-2">
                <div 
                  className="card-header" 
                  style={{ cursor: 'pointer', backgroundColor: '#f8f9fa' }}
                  onClick={() => toggleItem(index)}
                >
                  <div className="d-flex justify-content-between align-items-center">
                    <span>Tags {index + 1}</span>
                    <span>{openIndex === index ? '−' : '+'}</span>
                  </div>
                </div>
                {openIndex === index && (
                  <div className="card-body">
                    <div className="details-listing">

                      {obj?.status && obj?.status !== null && (
                        <div className="details-list">
                          <strong className="data-title">Tag Payment Status</strong>
                          <span className="data-details">
                            {obj?.status}
                          </span>
                        </div>
                      )}
                      {obj?.name && (
                        <div className="details-list">
                          <strong className="data-title">
                            {localization.mat}
                          </strong>
                          <span className="data-details">
                            {obj?.name ? obj.name : localization.na}
                          </span>
                        </div>
                      )}
                      <div className="details-list">
                        <strong className="data-title">
                          {localization.quantity}
                        </strong>
                        <span className="data-details">
                          {obj?.qty ? obj.qty : localization.na}
                        </span>
                      </div>
                      {obj?.price && obj?.price !== null && (
                        <div className="details-list">
                          <strong className="data-title">Price</strong>
                          <span className="data-details">
                            {obj?.price ? obj.price : localization.na}
                          </span>
                        </div>
                      )}
                      <div className="details-list">
                        <strong className="data-title">
                          {localization.specification}
                        </strong>
                        <span className="data-details">
                          {obj?.remark ? obj.remark : localization.na}
                        </span>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

TagsInventoryDetail.propTypes = {
  heading: PropTypes.string,
  details: PropTypes.array
};

export default TagsInventoryDetail;
